"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var Button_1 = require("../Button");
var Settings_1 = require("../Icon/Feather/Settings");
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  display: inline-block;\n  top: 24px;\n  right: 0;\n"], ["\n  position: absolute;\n  display: inline-block;\n  top: 24px;\n  right: 0;\n"])));
var ChartSettingsIcon = /** @class */ (function (_super) {
    __extends(ChartSettingsIcon, _super);
    function ChartSettingsIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChartSettingsIcon.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsx)(Button_1["default"], __assign({ incidentail: true, onClick: this.props.onClick.bind(this) }, { children: (0, jsx_runtime_1.jsx)(Settings_1["default"], { size: 20 }) })) }));
    };
    return ChartSettingsIcon;
}(react_1.PureComponent));
exports["default"] = ChartSettingsIcon;
var templateObject_1;
